import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { ResponseDto } from '../models/dto/response';
import { AssignVRSDto } from '../models/dialog-dto/assign-vrs.dto';
import {
  EasybillLastSyncDto,
  EasybillOrderSelection,
  EasybillSyncResult,
  EasybillSyncSummary,
} from '../models/dialog-dto/easybill-sync.dto';

/**
 * EasybillService is a thin RestService wrapper for the Easybill sync endpoints.
 * Dry-run and confirm are split into separate methods per sync type (rather than
 * a single method with a `confirm` flag) so the differing dry-run/confirm return
 * shapes (EasybillSyncSummary vs. EasybillSyncResult) stay type-safe.
 */
@Injectable({
  providedIn: 'root',
})
export class EasybillService {
  constructor(private _restService: RestService) {}

  dryRunProducts() {
    return this._restService.post<EasybillSyncSummary>('/easybill/sync/products', {});
  }

  confirmProducts(selections: string[]) {
    return this._restService.post<EasybillSyncResult>('/easybill/sync/products?confirm=true', { selections });
  }

  dryRunArticles() {
    return this._restService.post<EasybillSyncSummary>('/easybill/sync/articles', {});
  }

  confirmArticles(selections: string[]) {
    return this._restService.post<EasybillSyncResult>('/easybill/sync/articles?confirm=true', { selections });
  }

  dryRunCompanies() {
    return this._restService.post<EasybillSyncSummary>('/easybill/sync/companies', {});
  }

  confirmCompanies(selections: string[]) {
    return this._restService.post<EasybillSyncResult>('/easybill/sync/companies?confirm=true', { selections });
  }

  dryRunOrders() {
    return this._restService.post<EasybillSyncSummary>('/easybill/sync/orders', {});
  }

  confirmOrders(selections: EasybillOrderSelection[]) {
    return this._restService.post<EasybillSyncResult>('/easybill/sync/orders?confirm=true', { selections });
  }

  getLastSync() {
    return this._restService.get<EasybillLastSyncDto>('/easybill/last-sync');
  }

  assignVRS(licenceGuid: string, data: AssignVRSDto) {
    return this._restService.post<ResponseDto>(`/easybill/orders/${licenceGuid}/assign-vrs`, data);
  }
}
